import React, { useEffect, useState } from "react";
import { CardText, Row, Col } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions"
import "./styles.scss"
import HomeService from "services/Website/HomeService"
import { SuccessOk } from "configs/statusCode";
import { useTranslation } from 'react-i18next';
import {paymentOptions} from 'Enums/fixedData';
import AreaService from "services/Website/AreaServic";
import CompoundService from "services/Website/CompoundService";
import RoomFilter from "./RoomFilter";


const SideFilters = ({ id, type ,setLoading,loading}) => {
  const filterData = useSelector(state => state.filter);
  const AuthData = useSelector(state => state.Auth)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const compoundService = new CompoundService()

  const showLoading=()=>setLoading(true)


  // useEffect(()=>{
  //   compoundService?.getCompoundSpecifications(id).then(response=>{
  //     if (response && response.status === SuccessOk) {
  //       dispatch(appendFilters({
  //         // budgetRange: [!!response.data.minBudget ? parseInt(response.data.minBudget) : 0, !!response.data.maxBudget ? parseInt(response.data.maxBudget) : 1],
  //         // budget: [!!response.data.minBudget ? parseInt(response.data.minBudget) : 0, !!response.data.maxBudget ? parseInt(response.data.maxBudget) : 1],
  //         budgetRange: (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget],
  //         budget: (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget],
  //         sizeRange: (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)],
  //         size: (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)],
  //         // size: [!!response.data.minSize ? parseInt(response.data.minSize) : 0, !!response.data.maxSize ? parseInt(response.data.maxSize) : 1],
  //         bathroomsRange: parseInt(response.data.minBathrooms) !== parseInt(response.data.maxBathrooms) ? [parseInt(response.data.minBathrooms) , parseInt(response.data.maxBathrooms) ] : [parseInt(response.data.minBathrooms)],
  //         bedroomsRange: parseInt(response.data.minBedrooms) !== parseInt(response.data.maxBedrooms) ? [parseInt(response.data.minBedrooms) , parseInt(response.data.maxBedrooms) ] : [parseInt(response.data.minBedrooms)],
  //         floorRange: parseInt(response.data.minFloor) !== parseInt(response.data.maxFloor) ? [parseInt(response.data.minFloor) , parseInt(response.data.maxFloor) ] : [parseInt(response.data.minFloor)],
  //         CategortiesOptions: response.data.categories?.map(type=>{
  //           return{
  //             name: type?.name,
  //             value: type?.id,
  //             label: type?.name[AuthData?.lang]
  //           }
  //         }) ,
  //         finishingOptions: response.data.finishing_types ,
  //         unitTypeOptions: response.data.unit_types?.map(type=>{
  //           return{
  //             name: type?.name,
  //             value: type?.id,
  //             label: type?.name[AuthData?.lang]
  //           }
  //         }) ,
  //         getRanges:true,
  //       }))
  //       showLoading()
  //     }
  //   })
  // },[id])

  const onSlide = (...rest) => {
    dispatch(appendFilters({ budget: rest[0] }))
    showLoading()
  };

  const onSlideSize = (...rest) => {
    dispatch(appendFilters({ size: rest[2] }))
    showLoading()
  };

  return (
    <div className=' p-3'style={{position:"relative", background:"#ffffff", "boxShadow": "0 0 5px #dedede"}}>
    {loading ? <div style={{opacity:".6",zIndex:300,background:"#ffffff",position:"absolute",width:"100%",height:"100%",top:0,left:0}}></div>:null}
      <AvForm >
           <div className='mb-2 d-flex flex-row-reverse'>
            <button
              className='btn shadow-none rest-Btn font-size-14 text-dark px-0 '
              type="button"
              onClick={() =>{
                dispatch(resetFilters())
                showLoading()
              }}>{t("reset all")}</button>
          </div>

          <CardText tag='h6' className="fw-bold pt-3">{t("property type")}</CardText>
          <div
            className='d-block btn-group-toggle'
            data-toggle='buttons'>
            {filterData?.unitTypeOptions?.map((type, index) => {
              return (
                <span key={index}>
                  <input
                    type='checkbox'
                    className='btn-check'
                    name='UnitType'
                    id={`btncheckType${index}`}
                    autoComplete='off'
                    checked={filterData?.unitType?.some(item => item?.name?.en === type ?.name?.en)}
                    onChange={() => { }}
                  />
                  <label
                    onClick={() => {
                      const isExist = filterData?.unitType?.some(item => item?.name?.en === type ?.name?.en)
                      if (!isExist) {
                        dispatch(appendFilters({ unitType: [...filterData.unitType, type] }))
                      } else {
                        const updatedData = filterData?.unitType?.filter(item => item?.name?.en !== type ?.name?.en)
                        dispatch(appendFilters({ unitType: [...updatedData] }))
                      }
                      showLoading()
                    }}

                    className='btn btn-outline-light    me-2'
                    style={{
                      background: filterData?.unitType?.some(item => item?.name?.en === type ?.name?.en) ? "#0583f2" : "#f5f5f5",
                      color: filterData?.unitType?.some(item => item?.name?.en === type ?.name?.en) ? "#fff" : "#000",
                    }}
                    htmlFor='UnitType'>
                    {type?.name?.en}
                  </label>
                </span>
              )
            })}
          </div>
          <hr />
          
          <CardText tag='h6' className='fw-bold'>
             {t("finishing")}
          </CardText>
          <div
            className='d-block btn-group-toggle'
            data-toggle='buttons'>
            {filterData?.finishingOptions?.map((type, index) => {
              return (
                <span key={index + 1}>
                  <input
                    type='checkbox'
                    className='btn-check'
                    name='typeFinish'
                    id={`typeFinish${index + 1}`}
                    autoComplete='off'
                    checked={filterData?.finishingType?.some(item => item?.name?.en === type?.name?.en)}

                    onChange={() => { }}
                  />
                  <label
                    style={{
                      background: filterData?.finishingType?.some(item => item?.name?.en === type?.name?.en) ? "#0583f2" : "#f5f5f5",
                      color: filterData?.finishingType?.some(item => item?.name?.en === type?.name?.en) ? "#fff" : "#000",
                    }}
                    onClick={() => {
                      const isExist = filterData?.finishingType?.some(item => item?.name?.en === type?.name?.en)
                      if (!isExist) {
                        dispatch(appendFilters({ finishingType: [...filterData.finishingType, type] }))
                        showLoading()
                      } else {
                        const updatedData = filterData?.finishingType?.filter(item => item?.name?.en !== type?.name?.en)
                        dispatch(appendFilters({ finishingType: [...updatedData] }))
                        showLoading()
                      }
                    }}
                    className='btn btn-outline-light me-2'
                    htmlFor='btncheckType'>
                    {type?.name?.en}
                  </label>
                </span>
              )
            })}
          </div>

          <hr />
            <CardText tag='h6' className='fw-bold'>
              {t("Categories")}
            </CardText>
            <div
              className='d-block btn-group-toggle pt-1'
              data-toggle='buttons'>
              {filterData.CategortiesOptions.map((type, index) => {
                return (
                  <span key={index}>
                    <input
                      type='checkbox'
                      className='btn-check'
                      name='typeCatogory'
                      id={`typeCatogory${index}`}
                      autoComplete='off'
                      onChange={() => { }}
                      checked={filterData.categories_ids.some(item => item?.name?.en === type ?.name?.en)}

                    />
                    <label
                      style={{
                        background: filterData.categories_ids.some(item => item?.name?.en === type ?.name?.en) ? "#0583f2" : "#f5f5f5",
                        color: filterData.categories_ids.some(item => item?.name?.en === type?.name?.en) ? "#fff" : "#000",
                      }}
                      onClick={() => {
                        const isExist = filterData.categories_ids.some(item => item?.name?.en === type?.name?.en)
                        if (!isExist) {
                          dispatch(appendFilters({ categories_ids: [...filterData.categories_ids, type] }))
                          showLoading()
                        } else {
                          const updatedData = filterData.categories_ids.filter(item => item?.name?.en !== type?.name?.en)
                          dispatch(appendFilters({ categories_ids: [...updatedData] }))
                          showLoading()
                        }
                      }}
                      className='btn btn-outline-light me-2'
                      htmlFor='btncheckType'>
                      {type?.name?.en}
                    </label>
                  </span>
                )
              })}
            </div>

          <hr />
          <div
            className='d-block btn-group-toggle'
            data-toggle='buttons'>
            <CardText tag='h6' className='fw-bold'>
            {t("Floors")}
            </CardText>
            <RoomFilter roomsType={"floorRange"} value={'floor'} showLoading={showLoading}  />
          </div>
          <hr />
          <div
            className='d-block btn-group-toggle'
            data-toggle='buttons'>
            <CardText tag='h6' className='fw-bold'>
              {t("Bedrooms")}
            </CardText>
            <RoomFilter roomsType={"bedroomsRange"} value={'bedrooms'} showLoading={showLoading} />
          </div>
          <hr />
          <div
            className='d-block btn-group-toggle'
            data-toggle='buttons'>
            <CardText tag='h6' className='fw-bold'>
            {t("Bathrooms")}
            </CardText>
            <RoomFilter roomsType={"bathroomsRange"} value={'bathrooms'} showLoading={showLoading}  />
          </div>

          <hr />
          {!!filterData.size && <div className='mt-2'>
            <CardText tag='h6' className='fw-bold'>
              {t("size")} ({t("sqm")})
            </CardText>
            <Row className=" d-flex justify-content-between mb-2">
              <Col md={6}><span className="fw-bold font-size-14 text-muted" > 
              { Math.round(filterData.size[0]) }
               </span>
               </Col>
              <Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
              <span className="fw-bold font-size-14"  >
              { Math.round(filterData.size[1])}
              
              </span></Col>
            </Row>
            {AuthData.lang==="ar" ?            <Nouislider
              range={{ min: filterData.sizeRange[0], max: filterData.sizeRange[1] }}
              tooltips={false}
              step={10}
              start={filterData.size}
              connect
              onSlide={onSlideSize}
              direction={"rtl"}
            />:null}
            {AuthData.lang!=="ar" ?  <Nouislider
              range={{ min: filterData.sizeRange[0], max: filterData.sizeRange[1] }}
              tooltips={false}
              step={10}
              start={filterData.size}
              connect
              onSlide={onSlideSize}
              direction={"ltr"}
            />:null}
          </div>}
          {!!filterData.size && <hr />}
          {!!filterData.budget && <div className='mt-2'>
            <CardText tag='h6' className='fw-bold' >{t("budget")}</CardText>
            <Row className=" d-flex justify-content-between mb-2">
              <Col md={6}>
              <span className="fw-bold font-size-14 text-muted" >
               {  toCurrency(filterData.budget[0])  } </span></Col>
              <Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
              <span className="fw-bold font-size-14"  > { toCurrency(filterData.budget[1]) } </span></Col>
            </Row>
           {AuthData.lang==="ar" ? <Nouislider
              range={{ min: filterData.budgetRange[0], max: filterData.budgetRange[1] }}
              step={5000}
              tooltips={false}
              start={filterData.budget}
              connect
              onSlide={onSlide}
              direction={"rtl"}


            />:null}
            {AuthData.lang!=="ar"?<Nouislider
            range={{ min: filterData.budgetRange[0], max: filterData.budgetRange[1] }}
            step={5000}
            tooltips={false}
            start={filterData.budget}
            connect
            onSlide={onSlide}
            direction={"ltr"}


          />:null}
          </div>}
          {!!filterData.budget && <hr />}
          {type === "Unit" &&
            <div><label className="fw-bold">{t("Unit Code")}</label>
              <AvField
              id={"propertyNamme"}
                name='Unit Code'
                placeholder={t("Unit Code")}
                className='fotm-control btnHeight mb-2'
                value={filterData.unit}
                onChange={(e) =>{
                   dispatch(appendFilters({ unit: e.target.value }))
                   }}

              /></div>}
          <br />
       </AvForm>
    </div>
  );
};

const toCurrency = (number) => {
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(number);
}
const getFixed = (number) => number.toFixed(0)

export default SideFilters;